import deepmerge from 'deepmerge';

import buildParamsUrl from './buildParamsUrl';
import extractNodeLevelData from './extractNodeLevelData';
import camelizePath from './camelizePath';

function generatePathObject({ metadata, pathBase, prefixFn, history }) {
  const pathObject = {
    metadata,
    path: params => buildParamsUrl(prefixFn(pathBase), params),
    url: pathBase,
  };

  if (history) {
    pathObject.goTo = function goTo(params) { history.push(pathObject.path(params)); };
  }

  return pathObject;
}

function buildNestedRoute(node, prefixFn, history, path = [], metadata = {}) {
  const { thisLevelMetadata, route } = extractNodeLevelData(node);

  const baseObject = {};
  if (path.length === 0) {
    baseObject.root = generatePathObject({
      metadata: thisLevelMetadata,
      prefixFn,
      history,
      pathBase: '',
    });
  }

  return route.reduce((all, key) => {
    const nextLevel = extractNodeLevelData(node[key]);
    const nextLevelMetadata = nextLevel.thisLevelMetadata;
    const nextRoutes = nextLevel.route;
    const newPath = [...path, key];

    let routeKey = camelizePath(newPath.filter(part => part.indexOf(':') !== 0), false);
    const pathBase = newPath.join('/');

    let childRoutes = {};
    if (nextRoutes.length > 0) {
      childRoutes = buildNestedRoute(
        node[key],
        prefixFn,
        history,
        newPath,
        deepmerge(metadata, thisLevelMetadata),
      );

      routeKey += 'Index';
    }

    if (
      all[routeKey] ||
      newPath[newPath.length - 1].indexOf(':') === 0
    ) { return { ...all, ...childRoutes }; }

    return {
      ...all,
      [routeKey]: generatePathObject({
        metadata: deepmerge(deepmerge(metadata, thisLevelMetadata), nextLevelMetadata),
        pathBase,
        prefixFn,
        history,
      }),
      ...childRoutes,
    };
  }, baseObject);
}

export default function jsUi(routes, prefixFn, history) {
  return buildNestedRoute(routes, prefixFn, history);
}
